import styled from 'styled-components'

import _AffirmLogo from '~/components/affirm-logo'
import Card, { CardHeader } from '~/components/card'
import { font } from '~/styles/utils'

export const StyledCard = styled(Card)`
  && {
    padding: 0;
    margin: 65px 0;
  }
`

export const StyledCardHeader = styled(CardHeader)`
  && {
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: normal;
    column-gap: 20px;
  }
`

export const SubHeader = styled.h3`
  margin: 35px 0 25px;
  font-size: 18px;
  ${font('bold')};
`
export const LogoWrapper = styled.div`
  width: 65px;
  padding: 0 0 0 10px;
`

export const AffirmLogo = styled(_AffirmLogo)`
  width: 100%;
`

export const Title = styled.h2`
  font-size: 24px;
  margin: 0;
  ${font('bold')}';
`
